import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AllCommunityModule, ModuleRegistry, enableDevValidations, provideGlobalGridOptions } from 'ag-grid-community';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// ag-grid v33+ requires explicit module registration before any grid is created.
ModuleRegistry.registerModules([AllCommunityModule]);
// Keep the legacy CSS themes (ag-theme-alpine) instead of the v33 Theming API — set once, globally.
// paginationPageSizeSelector:false hides ag-grid's built-in page-size dropdown (new default in v32+); the app
// paginates via its own app-paging-tool, matching the original (pre-upgrade) look.
provideGlobalGridOptions({ theme: 'legacy', paginationPageSizeSelector: false });

// ag-grid v36 dropped ValidationModule from AllCommunityModule to keep production bundles small; without it
// grid-option/colDef mistakes log only an error code + doc link. Opt back into the full diagnostics off-prod.
if (!environment.production) {
  enableDevValidations();
}

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch(err => console.error(err));
